import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import useConfirmationAlert from '../../../../hooks/componentHooks/useConfirmationAlert'
import EventForm from '../EventForm'
import { gradientColors, textColors } from '../../../Common/Color/Color'
import { fontSizes } from '../../../Common/Typography/TypographyStyles'

const EventCreateModal = () => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [open, setOpen] = useState(false)
  const [formHasChanges, setFormHasChanges] = useState(false)

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleFormChanges = React.useCallback((hasChanges: boolean) => {
    setFormHasChanges(hasChanges)
  }, [])

  const { ConfirmationAlert, openConfirmationAlert } = useConfirmationAlert()

  const handleCloseModal = () => {
    if (formHasChanges) {
      openConfirmationAlert({
        title: 'Discard changes',
        text: 'Are you sure you want to discard your changes?',
        onConfirm: () => {
          setOpen(false)
        },
      })
    } else {
      setOpen(false)
    }
  }

  // Callback function to close the modal after saving
  const handleCloseModalAfterSave = () => {
    setOpen(false)
  }

  return (
    <React.Fragment>
      <Button variant='text' id='create-event-button' startIcon={<AddIcon />} onClick={handleOpenModal}>
        Create Event
      </Button>
      <Dialog open={open} fullWidth fullScreen={fullScreen}>
        <DialogTitle
          sx={{
            background: gradientColors.greenGradient,
            color: textColors.white,
            fontWeight: 'bold',
            fontSize: fontSizes.size20,
          }}
        >
          Create Event
        </DialogTitle>
        <IconButton
          onClick={handleCloseModal}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            color: textColors.white,
          }}
          size='small'
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <EventForm onSave={handleCloseModalAfterSave} onChange={handleFormChanges} />
        </DialogContent>
      </Dialog>
      {ConfirmationAlert}
    </React.Fragment>
  )
}

export default EventCreateModal
